<mat-form-field>
  <input matInput [formControl]="control" />
  <mat-error><lin-form-field-error></lin-form-field-error></mat-error>
</mat-form-field>
